/**
 * Centralized permission groups for the Staff Panel
 */

export const BASIC_STAFF_ROLES = [
    'suporte',
    'suporte_compras',
    'suporte_descontos',
    'moderador',
    'super_moderador',
    'programador',
    'head_suporte',
    'head_moderacao',
    'head_staff',
    'analista_qualidade',
    'departamento_juridico',
    'admin',
    'direcao'
];

export const ADVANCED_STAFF_ROLES = [
    'programador',
    'head_suporte',
    'head_moderacao',
    'head_staff',
    'analista_qualidade',
    'departamento_juridico',
    'admin',
    'direcao'
];

export const CONTENT_CREATOR_ROLES = [
    'criador_de_conteudo'
];

export const ALL_STAFF_ROLES = [
    ...BASIC_STAFF_ROLES,
    ...CONTENT_CREATOR_ROLES
];

// Helper to check if a user has any of the roles
export const hasAnyRole = (userRole, allowedRoles) => {
    return allowedRoles.includes(userRole);
};
